var map = {
	"./arrow-right.svg": 57317,
	"./arrow-uturn-up-cross.svg": 96050,
	"./bell-notification-alarm.svg": 11763,
	"./box-delivery-package-car-pin-location-group.svg": 8603,
	"./button-arrow-left-circle.svg": 22019,
	"./button-arrow-right-circle.svg": 21155,
	"./calculator.svg": 24197,
	"./calendar-31.svg": 66478,
	"./calendar-add-circle.svg": 6673,
	"./checkmark-done-check.svg": 12797,
	"./checkmark-square-empty.svg": 52587,
	"./checkmark-square.svg": 87141,
	"./chevron-down.svg": 20949,
	"./chevron-left.svg": 10530,
	"./chevron-right.svg": 71448,
	"./chevron-up.svg": 91048,
	"./cloud-upload.svg": 6099,
	"./column-artboard.svg": 84126,
	"./contract-document-seal.svg": 45395,
	"./credit-card-security-protection.svg": 20537,
	"./cross-head-circle.svg": 23569,
	"./cursor-swipe-down.svg": 5885,
	"./cursor-swipe-left.svg": 88118,
	"./cursor-swipe-right.svg": 78015,
	"./cursor-swipe-up.svg": 18893,
	"./dashboard-6.svg": 13955,
	"./delete-disabled-cross.svg": 22125,
	"./delete-disabled.svg": 31436,
	"./delivery-shipment-packages-setting.svg": 95992,
	"./document-cross-delete-left.svg": 17244,
	"./document-edit.svg": 89760,
	"./document-file-cross-deelte.svg": 45364,
	"./document-file-cross-delete-circle.svg": 77734,
	"./document-file-download.svg": 58635,
	"./document-file-eye.svg": 12643,
	"./documents-file-add-plus.svg": 90392,
	"./documents-file-arrow.svg": 17274,
	"./documents-file-delete-cross.svg": 61415,
	"./documents-file-search.svg": 45379,
	"./done-check-checkmark.svg": 45823,
	"./download-square.svg": 71559,
	"./earth-home-world.svg": 39697,
	"./email-mail-checkmark.svg": 16547,
	"./eye-cross.svg": 81706,
	"./eye-open.svg": 34013,
	"./file-blank-add-plus.svg": 80994,
	"./list-basket-checkmark.svg": 73888,
	"./lock-3.svg": 55001,
	"./lock-shield-prote.svg": 47748,
	"./lock-unlock.svg": 54851,
	"./menu-burger-arrow-circle.svg": 86563,
	"./menu-edit-pen-add-circle.svg": 44541,
	"./package-box-arrow-up.svg": 83148,
	"./package-box-arrow.svg": 76958,
	"./package-box-warning.svg": 47781,
	"./pen-edit.svg": 92715,
	"./search-1.svg": 96286,
	"./setting-edit-filter-gear-square-1.svg": 47553,
	"./settings-circle-2.svg": 68092,
	"./shield-protection-square.svg": 3516,
	"./shopping-cart.svg": 38010,
	"./single-user-add-plus.svg": 52435,
	"./single-user.svg": 60471,
	"./slides-windows.svg": 94065,
	"./support-headphones.svg": 16854,
	"./trash-delete-bin-2.svg": 18770,
	"./user-profile-square.svg": 27936,
	"./warehouse-delivery.svg": 21831
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91839;